import styled from "styled-components";
import { Variables } from "../../styles/Variables";

export const OptionCardContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  background-color: ${Variables.colorWhite};
  border-radius: 5px;
  padding: 20px;
  height: 110px;
  text-align: start;
  transition: transform 0.2s;
  cursor: pointer;

  &:hover {
    transform: scale(1.05);
  }

  @media (max-width: ${Variables.maxMobile}) {
    height: 130px;
  }
`;

export const ContainerTexts = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 65%;
`;

export const Title = styled.p`
  font-size: 17px;
  font-weight: 600;
  color: ${Variables.colorBlackDark};
`;

export const OptionText = styled.p`
  font-size: 14px;
  color: ${Variables.colorBlackDark};
`;

export const OptionIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30%;
  height: 96%;
  border-radius: 100px;
  background-color: ${Variables.colorPink};
`;
